// extracted by mini-css-extract-plugin
export default {"Comentarios":"Comentarios_Comentarios__mBmTl"};